import { Link } from "react-router-dom";
import { Calendar, MapPin, ArrowRight } from "lucide-react";

export function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch { return iso; }
}

export default function EventCard({ event, refCode }) {
  const from = event.ticket_types?.length ? Math.min(...event.ticket_types.map((t) => t.price)) : null;
  const href = `/events/${event.slug}${refCode ? `?ref=${refCode}` : ""}`;
  return (
    <Link to={href} className="group block card-warm rounded-2xl overflow-hidden hover:border-[#e0481f]/50 transition-colors" data-testid={`event-card-${event.slug}`}>
      <div className="relative h-52 overflow-hidden">
        <img src={event.banner_image || event.flyer_image} alt={event.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#121110] via-transparent to-transparent" />
        <span className="absolute top-3 left-3 bg-[#e0481f] text-white text-xs font-display font-700 uppercase tracking-wider px-3 py-1 rounded-full">{event.category}</span>
      </div>
      <div className="p-5">
        <h3 className="headline text-2xl text-[#f7f3ec] mb-1">{event.title}</h3>
        <p className="text-[#d4af37] text-sm mb-3">{event.subtitle}</p>
        <div className="flex flex-col gap-1.5 text-sm text-[#a9a196] mb-4">
          <span className="flex items-center gap-2"><Calendar size={15} className="text-[#e0481f]" /> {formatDate(event.date)}</span>
          <span className="flex items-center gap-2"><MapPin size={15} className="text-[#e0481f]" /> {event.location}</span>
        </div>
        <div className="flex items-center justify-between">
          {from != null && <span className="text-[#f7f3ec]"><span className="text-xs text-[#8f857a]">from </span><span className="headline text-xl gold-text">${from}</span></span>}
          <span className="inline-flex items-center gap-1.5 text-[#f3c649] font-display uppercase text-sm tracking-wide group-hover:gap-2.5 transition-all">Get Tickets <ArrowRight size={16} /></span>
        </div>
      </div>
    </Link>
  );
}
